export const roleIsAllowed = (
  userRoles: Array<string>,
  authorizedRoles: Array<string>
) => {
  if (!authorizedRoles) return true;
  return userRoles.some((role) => authorizedRoles.includes(role));
};
